import { FC, useMemo } from 'react';
import { useLocalizedFormat } from '../../lib/date-fns';
import { TSelectedRange } from '../date-pick';
import { DateRangeContent } from '../date-range-content';
import { DropDown } from '../drop-down';
import { DropDownProvider } from '../drop-down/drop-down.provider';
import { FieldText } from '../field-text';
import { CalendarIcon } from '../icons';
import { IDateFieldProps } from './date-field.types';

const defaultDateFormat = 'd MMMM yyyy HH:mm';

export const DateField: FC<IDateFieldProps> = ({
  onDateChange,
  range,
  ...props
}) => {
  const { format } = useLocalizedFormat();
  const dateFormat = useMemo(
    () => props.format || defaultDateFormat,
    [props.format],
  );

  const formattedRange = useMemo(() => {
    const [startDate, endDate] = range;

    if (!startDate || !endDate) {
      return '';
    }

    return `${format(startDate, dateFormat)} - ${format(endDate, dateFormat)}`;
  }, [dateFormat, format, range]);

  const applyHandler = (value: TSelectedRange) => {
    onDateChange(value);
  };

  const clearHandler = () => {
    onDateChange([]);
  };

  return (
    <DropDownProvider>
      <DropDown
        content={<DateRangeContent onApply={applyHandler} ranges={range} />}
        offset={4}
        placement="bottom-start"
        useParentWidth={false}
      >
        <FieldText
          {...props}
          icon={<CalendarIcon />}
          readOnly
          isClearable
          value={formattedRange}
          onClear={clearHandler}
          cursor="pointer"
          width="360px"
        />
      </DropDown>
    </DropDownProvider>
  );
};
